import React from 'react'
import PropTypes from 'prop-types';
import _ from "underscore";

// Logic, logic, logic
// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Logic = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Logic' id='logic' iconclass='category with-icon-paths snap-icon-logic_dual'>{/* NOSONAR */}
                <label text="Logic"/>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Logic.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Logic;